import React from "react";
import { LiveProvider, LiveEditor, LiveError, LivePreview } from 'react-live';
import theme from 'prism-react-renderer/themes/nightOwlLight';

export default { React, LiveProvider, LiveEditor, LiveError, LivePreview, theme }